import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import ExampleItemView from "./ExampleItemView";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";

export default class BottomHudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;
        this._target.findLabelTextfield.text = this.getText("hud.findLabel");

        this._sampleView = new ExampleItemView(this._target.bird);

        this._handleDoneClick = this._handleDoneClick.bind(this);
        this._buttonSubmit = this.createButton(this._target.button, this._handleDoneClick, this.getText("hud.buttonSubmit"));
        this._buttonSubmit.setEnabled(false);
    }

    enableSubmit(bool) {
        this._buttonSubmit.setEnabled(bool);
    }

    setSample(skin) {
        this._sampleView.content = skin;
    }

    crossFadeSample(skin, duration, delayBetween = 0) {
        //TODO: make nice (dont access private prop):
        const target = this._sampleView._target;
        if (isNull(target.origY)) {
            target.origY = target.y;
        }
        const origY = target.origY;
        createjs.Tween.get(target)
            .to({ alpha: 0, y: origY + 100 }, duration / 2, createjs.Ease.quadIn)
            .call(_ => {
                target.y = origY - 100;
                this.setSample(skin);
            })
            .wait(delayBetween)
            .to({ alpha: 1, y: origY }, duration / 2, createjs.Ease.quadOut);
    }

    _handleDoneClick() {
        this.dispatchEvent(BottomHudView.SUBMIT)
    }
}

BottomHudView.SUBMIT = "BottomHudView.SUBMIT";

function padTime(str) {
    return ("0" + str).substr(-2);
}